import FormLabel from '@mui/material/FormLabel';
import {
  TimeField as MuiTimeField,
  TimeFieldProps as MuiTimeFieldProps,
} from '@mui/x-date-pickers/TimeField';
import {
  TimePicker as MuiTimePicker,
  TimePickerProps as MuiTimePickerProps,
} from '@mui/x-date-pickers/TimePicker';
import React, { useState } from 'react';

import { Box } from './Box';

type OmittedProps = Omit<
  MuiTimePickerProps<Date>,
  'open' | 'onOpen' | 'onClose'
>;

export interface TimePickerProps extends OmittedProps {
  label: React.ReactNode;
  floatingLabel?: boolean;
  size?: MuiTimeFieldProps<Date>['size'];
  helperText?: string;
  error?: boolean;
  required?: boolean;
}

export const TimePicker: React.FC<TimePickerProps> = ({
  label,
  floatingLabel,
  size,
  helperText,
  error,
  required,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const fieldProps = {
    label,
    floatingLabel,
    size,
    helperText,
    error,
    required,
  } as any;

  return (
    <MuiTimePicker
      slots={{ field: TimeField, ...props.slots }}
      slotProps={{ field: fieldProps }}
      {...props}
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
    />
  );
};

interface TimeFieldProps extends MuiTimeFieldProps<Date> {
  floatingLabel?: boolean;
  required?: boolean;
}

export const TimeField: React.FC<TimeFieldProps> = ({ ...props }) => {
  const {
    helperText,
    label,
    floatingLabel,
    sx,
    size,
    fullWidth = true,
    required,
    ...otherProps
  } = props;

  return (
    <FormLabel
      sx={[
        { display: 'block' },
        fullWidth && { width: '100%' },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {!floatingLabel && label && (
        <Box sx={{ mb: 1 }}>
          {label}
          {required && <Box component="span"> *</Box>}
        </Box>
      )}
      <MuiTimeField
        {...otherProps}
        helperText={helperText}
        label={floatingLabel && label}
        size={size}
        fullWidth={fullWidth}
        required={required}
        hiddenLabel={!floatingLabel}
        InputProps={{
          sx: { boxShadow: 'none' },
          ...props.InputProps,
        }}
      />
    </FormLabel>
  );
};
